<template>
  <dialog-base
    v-bind:shows="shows"
    v-bind:initialize-callback="$_onInitialize"
    v-bind:ok-callback="$_okCallback"
    v-bind:finalize-callback="finalizeCallback"
  >
    <template v-slot:body>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <general-text-field
          dense autofocus
          v-model="$data.$_textTmp"
        >
        </general-text-field>
      </v-card-text>
    </template>
  </dialog-base>
</template>

<script>
import DialogBase from './DialogBase.vue';
import GeneralTextField from '../Parts/Inputs/GeneralTextField.vue';

export default {
  components: {
    DialogBase,
    GeneralTextField,
  },

  props: {
    shows:            { type: Boolean },
    okCallback:       { type: Function },
    finalizeCallback: { type: Function },
    title:            { type: String },
    text:             { type: String },
  },

  data() {
    return {
      $_textTmp: undefined,
    };
  },

  watch: {
    text() { this.$_onInitialize() },
  },

  methods: {
    $_onInitialize() {
      this.$data.$_textTmp = this.text;
    },

    $_okCallback() {
      this.okCallback(this.$data.$_textTmp);
    },
  },
}
</script>